import { AuthContext } from '@repo-level/core-front';
import { useContext } from 'react';
import { useCurrentLottery } from './useCurrentLottery';
import { useLotteryAccess } from './useLotteryAccess';

export const useLotteryMenuItem = () => {
  const { pendingUser } = useContext(AuthContext);
  const { cmsLottery, pending } = useCurrentLottery();
  const isAllowed = useLotteryAccess();

  if (pendingUser || pending) return false;

  return !!cmsLottery && isAllowed(cmsLottery);
};
